export interface ODataResult<T>{
    d: T extends Array<any> ? ResultsLayer<T> : T;
}

interface ResultsLayer<T> {
    results: T;
}

export const isODataResult = (object: any) => object && typeof object === 'object' && 'd' in object && (('results' in object.d && object.d.results instanceof Array) || '__metadata' in object.d);
